import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "instagram",
  "use": "instagram-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"instagram\"><path d=\"M412 256c0-11-2-19-5-30h105v207c0 21-6 41-23 58-15 15-35 23-56 23H79c-21 0-41-8-56-23-17-20-23-37-23-60V224h105c-3 13-3 23-3 30 0 43 15 79 45 109s66 44 109 44 79-14 109-44c30-28 47-64 47-107M433 0c21 0 41 6 56 23 17 15 23 35 23 56v87H382c-32-42-73-66-126-66-55 0-96 22-126 66H0V79c0-21 6-41 23-56C38 6 58 0 79 0h354m36 98V55c0-8-4-12-12-12h-43c-9 0-15 4-15 15v42c0 5 2 7 4 9 4 4 7 4 11 4h43c8 0 12-4 12-15M352 256c0 28-9 49-28 68s-40 28-68 28-49-11-68-28-28-40-28-68 11-49 28-68c19-17 40-28 68-28s49 9 68 28c17 19 28 40 28 68\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.svg
// module id = 195
// module chunks = 0